import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";
import { API_BASE } from "../utils/api/api";

const client = new ApolloClient({
  link: new HttpLink({ uri: `${API_BASE}/graphql` }),
  cache: new InMemoryCache(),
});


export default client;
